import React from "react";
import {
  QuotationInfo,
  // QuotationInfoType,
  IQuotationType,
} from "./Quotation.types";
import {
  ErrorsDefaultState,
  InitialQuotationInfo,
  QuotationExpiryDays,
} from "./Common/QuotationData";
import { IQuoteErrors } from "./Common/Interfaces/IQuoteErrors";
import { addDays } from "../../Utils/Date";

export const today = new Date();
export const expirationDate = addDays(today.toUTCString(), QuotationExpiryDays);
export const QuotationContext = React.createContext<IQuotationType | null>(
  null
);
export const QuotationProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [quotationInfo, setQuotationInfoData] =
    React.useState<QuotationInfo>(InitialQuotationInfo);
  const [quotationError, setQuotationErrorData] =
    React.useState<IQuoteErrors>(ErrorsDefaultState);

  const setQuotationInfo = (quotationInfoObj: QuotationInfo) => {
    setQuotationInfoData({
      ...quotationInfoObj,
      quotationId: quotationInfoObj.quotationId,
      partitionKey: quotationInfoObj.partitionKey,
      quotationNumber: quotationInfoObj.quotationNumber,
      quotationName: quotationInfoObj.quotationName,
      quotationDescription: quotationInfoObj.quotationDescription,
      quotationDate: quotationInfoObj.quotationDate,
      expiryDate: quotationInfoObj.expiryDate
        ? quotationInfoObj.expiryDate
        : expirationDate,
      customerRequestedPromiseDate: quotationInfoObj.customerRequestedPromiseDate,
      total: quotationInfoObj.total,
      totalTax: quotationInfoObj.totalTax,
      subTotal: quotationInfoObj.subTotal,
      totalFee: quotationInfoObj.totalFee,
      customer: quotationInfoObj.customer,
      // companyDetail: quotationInfoObj.companyDetail,
      // authorizedBuyers: quotationInfoObj.authorizedBuyers,
      // billingProfile: quotationInfoObj.billingProfile,
      // shipTo: quotationInfoObj.shipTo,
      // billTo: quotationInfoObj.billTo,
      status: quotationInfoObj.status,
      msxOpportunityId: quotationInfoObj.msxOpportunityId,
      paymentType: quotationInfoObj.paymentType,
      selectedPaymentType: quotationInfoObj.selectedPaymentType,
      paymentMethod: quotationInfoObj.paymentMethod,
      selectedPaymentMethod: quotationInfoObj.selectedPaymentMethod,
      paymentTerms: quotationInfoObj.paymentTerms,
      selectedPaymentTerms: quotationInfoObj.selectedPaymentTerms,
      customerPurchaseOrder: quotationInfoObj.customerPurchaseOrder,
      deliveryMode: quotationInfoObj.deliveryMode,
      selectedDeliveryMode: quotationInfoObj.selectedDeliveryMode,
      deliveryReason: quotationInfoObj.deliveryReason,
      selectedDeliveryReason: quotationInfoObj.selectedDeliveryReason,
      quoteCurrency: quotationInfoObj.quoteCurrency,
      comments: quotationInfoObj.comments,
      // comments: quotationInfoObj.comments
      //   ? quotationInfoObj.comments
      //   : `Your quote will expire on ${new Date(
      //       expirationDate
      //     ).toDateString()}`,
      microsoftAccountLead: quotationInfoObj.microsoftAccountLead,
      microsoftAccountPhone: quotationInfoObj.microsoftAccountPhone,
      microsoftAccountEmail: quotationInfoObj.microsoftAccountEmail,
      createdBy: quotationInfoObj.createdBy,
      createdByName: quotationInfoObj.createdByName,
      modifiedById: quotationInfo.modifiedById,
      modifiedByName: quotationInfo.modifiedByName,
      country: quotationInfoObj.country ? quotationInfoObj.country : quotationInfoObj?.customer?.selectedShipToAddress?.country,
      quoteLineItems: quotationInfoObj.quoteLineItems,
      quoteLineItemsClone: quotationInfoObj.quoteLineItemsClone,
      // lineItems: quotationInfoObj.lineItems,
      standaloneItems: quotationInfoObj.standaloneItems,
      standaloneItemsClone: quotationInfoObj.standaloneItemsClone,
      bundles: quotationInfoObj.bundles,
      bundleItems: quotationInfoObj.bundleItems,
      bundleItemsClone: quotationInfoObj.bundleItemsClone,
      searchedSku: quotationInfoObj.searchedSku,
      skuData: quotationInfoObj.skuData,
      taxExpirationDate: quotationInfoObj.taxExpirationDate
    } as QuotationInfo);
  };
  const setQuotationError = (quotationError: IQuoteErrors) => {
    setQuotationErrorData({
      ...quotationError,
      customerAccount: quotationError.customerAccount,
      quotationNumber: quotationError.quotationNumber,
      msxOpportunityId: quotationError.msxOpportunityId,
      paymentType: quotationError.paymentType,
      paymentMethod: quotationError.paymentMethod,
      paymentTerms: quotationError.paymentTerms,
      customerPurchaseOrder: quotationError.customerPurchaseOrder,
      deliveryMode: quotationError.deliveryMode,
      deliveryReason: quotationError.deliveryReason,
      quoteLineItems: quotationError.quoteLineItems,
      comments: quotationError.comments,
      preparedBy: quotationError.preparedBy,
      expirationDate: quotationError.expirationDate,
    });
  };
  return (
    <QuotationContext.Provider
      value={{
        quotationInfo,
        setQuotationInfo,
        quotationError,
        setQuotationError,
      }}
    >
      {children}
    </QuotationContext.Provider>
  );
};
